import { SeriesPointXY } from '@bitrise/bitviz';

export default (
  data: (null | number)[][],
  xAxisTicks: number[],
): [SeriesPointXY[][], [number, number]] => {
  const series: SeriesPointXY[][] = [];
  let yLower: undefined | number;
  let yUpper: undefined | number;

  for (const dataPoints of data) {
    const points: SeriesPointXY[] = [];

    for (let x = 0; x < xAxisTicks.length; x += 1) {
      const value = dataPoints[x] === undefined ? null : dataPoints[x];

      if (value !== null) {
        if (yLower === undefined || value < yLower) yLower = value;
        if (yUpper === undefined || value > yUpper) yUpper = value;
      }

      points.push({
        x: xAxisTicks[x],
        y: value,
      });
    }

    series.push(points);
  }

  if (yLower === undefined) yLower = 0;
  if (yUpper === undefined || yUpper === yLower) yUpper = yLower + 1;

  return [series, [yLower as number, yUpper as number]];
};
